import React, { useState } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
  TextInput,
} from "react-native";
import { deleteFinalAth } from "../action/authAction";
const { width, height } = Dimensions.get("window");
import { styles, stylesResponsive } from "./style/flatlistFinal";
import { useRecoilValue } from "recoil";
import { tokenState } from "../reducer/recoil";
import moment from "moment";

export default function flatlistFinal({
  user,
  onPress,
  data,
  navigation,
  allitem,
  name,
  route,
}) {
  const token = useRecoilValue(tokenState);
  return (
    <FlatList
      data={data}
      scrollEnabled={width >= 1280 ? false : true}
      renderItem={({ index, item }) => {
        return width >= 1280 ? (
          <View
            style={[
              styles.viewDetail,
              {
                backgroundColor: index % 2 == 0 ? "#CCE4FF" : "#FFFFFFbb",
                borderTopWidth: index >= 1 ? 0 : 1,
              },
            ]}
          >
            <Image
              resizeMode={"contain"}
              style={width < 1600 ? styles.imgDetailRespons : styles.imgDetail}
              source={{ uri: item.Athlete.image_url }}
            />
            <Text
              numberOfLines={1}
              style={[
                width < 1600 ? styles.textDetailRespons : styles.textDetail,
                { width: "15%" },
              ]}
            >
              {item.Athlete.first_name} {item.Athlete.last_name}
            </Text>
            {user && (
              <View style={{ width: "5%" }}>
                <TouchableOpacity
                  onPress={() => {
                    data.filter((val) => {
                      console.log(val);
                      if (val.athlete_id != null) {
                        if (val.Athlete.gender == "Male") {
                          allitem.approbation_details.athlete_male_numbers =
                            allitem.approbation_details.athlete_male_numbers -
                            1;
                        } else {
                          allitem.approbation_details.athlete_female_numbers =
                            allitem.approbation_details.athlete_female_numbers -
                            1;
                        }
                      } else if (val.official_id != null) {
                        if (val.Athlete.gender == "Male") {
                          allitem.approbation_details.official_male_numbers =
                            allitem.approbation_details.official_male_numbers -
                            1;
                        } else {
                          allitem.approbation_details.official_female_numbers =
                            allitem.approbation_details
                              .official_female_numbers - 1;
                        }
                      }
                    });
                    navigation.navigate("FinalEntryAthleteEdit", {
                      ...item,
                      ...allitem,
                      ...route.params,
                      type:
                        item.athlete_id != undefined && item.athlete_id != null
                          ? "Athlete"
                          : "Official",
                      name,
                    });
                  }}
                  style={styles.buttomDetail}
                >
                  <Text
                    style={
                      width < 1600
                        ? styles.textButtonDetailRespons
                        : styles.textButtonDetail
                    }
                  >
                    EDIT
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={async () => {
                    const res = await deleteFinalAth({
                      state: item.id,
                      token: token.token,
                    });
                    if (res) {
                      onPress();
                    }
                  }}
                  style={styles.buttomDetail}
                >
                  <Text
                    style={
                      width < 1600
                        ? styles.textButtonDetailRespons
                        : styles.textButtonDetail
                    }
                  >
                    DELETE
                  </Text>
                </TouchableOpacity>
              </View>
            )}
            <Text
              numberOfLines={1}
              style={[
                width < 1600 ? styles.textDetailRespons : styles.textDetail,
                { width: "8%" },
              ]}
            >
              {item.Athlete.gender}
            </Text>
            <Text
              numberOfLines={1}
              style={
                width < 1600 ? styles.textDetailRespons : styles.textDetail
              }
            >
              {moment(item.Athlete.birth_date).format("DD-MM-YYYY")}
            </Text>
            <Text
              numberOfLines={1}
              style={
                width < 1600 ? styles.textDetailRespons : styles.textDetail
              }
            >
              {item.Athlete.passport}
            </Text>
            <Text
              numberOfLines={1}
              style={
                width < 1600 ? styles.textDetailRespons : styles.textDetail
              }
            >
              {item.athlete_id != null ? "ATHLETE" : "OFFICIAL"}
            </Text>
            <View style={{ width: "10%" }}>
              {item.best_record != null &&
                item.best_record.map((e, i) => (
                  <Text
                    numberOfLines={1}
                    style={[
                      width < 1600
                        ? styles.textDetailRespons
                        : styles.textDetail,
                      { width: "100%", marginTop: i != 0 ? 10 : 0 },
                    ]}
                  >
                    {e.event}
                  </Text>
                ))}
            </View>
            <View style={{ width: "15%" }}>
              {item.best_record != null &&
                item.best_record.map((e, i) => (
                  <>
                    <Text
                      numberOfLines={1}
                      style={[
                        width < 1600
                          ? styles.textDetailRespons
                          : styles.textDetail,
                        { width: "100%", marginTop: i != 0 ? 10 : 0 },
                      ]}
                    >
                      {e.event}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[
                        width < 1600
                          ? styles.textDetailRespons
                          : styles.textDetail,
                        { width: "100%" },
                      ]}
                    >
                      {e.personal_best_stat}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[
                        width < 1600
                          ? styles.textDetailRespons
                          : styles.textDetail,
                        { width: "100%" },
                      ]}
                    >
                      {e.personal_best_date}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[
                        width < 1600
                          ? styles.textDetailRespons
                          : styles.textDetail,
                        { width: "100%" },
                      ]}
                    >
                      {e.personal_best_venue}
                    </Text>
                  </>
                ))}
            </View>
            <View style={{ width: "10%" }}>
              {item.best_record != null &&
                item.best_record.map((e, i) => (
                  <>
                    <Text
                      numberOfLines={1}
                      style={[
                        width < 1600
                          ? styles.textDetailRespons
                          : styles.textDetail,
                        { width: "100%", marginTop: i != 0 ? 10 : 0 },
                      ]}
                    >
                      {e.event}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[
                        width < 1600
                          ? styles.textDetailRespons
                          : styles.textDetail,
                        { width: "100%" },
                      ]}
                    >
                      {e.season_best_stat}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[
                        width < 1600
                          ? styles.textDetailRespons
                          : styles.textDetail,
                        { width: "100%" },
                      ]}
                    >
                      {e.season_best_date}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[
                        width < 1600
                          ? styles.textDetailRespons
                          : styles.textDetail,
                        { width: "100%" },
                      ]}
                    >
                      {e.season_best_venue}
                    </Text>
                  </>
                ))}
            </View>
          </View>
        ) : (
          <View
            style={[
              stylesResponsive.viewDetail,
              {
                backgroundColor: index % 2 == 0 ? "#CCE4FF" : "#FFFFFFbb",
                borderTopWidth: index >= 1 ? 0 : 1,
              },
            ]}
          >
            <Image
              resizeMode={"contain"}
              style={styles.imgDetail}
              source={{ uri: item.Athlete.image_url }}
            />
            <View style={{ width: "60%", marginLeft: 10 }}>
              <Text
                numberOfLines={1}
                style={[stylesResponsive.textTopic, { marginTop: 0 }]}
              >
                NAME
              </Text>
              <Text numberOfLines={1} style={[stylesResponsive.textDetail]}>
                {item.Athlete.first_name} {item.Athlete.last_name}
              </Text>

              {user && (
                <View
                  style={{
                    flexDirection: "row",
                  }}
                >
                  <TouchableOpacity
                    onPress={() => {
                      navigation.navigate("FinalEntryAthleteEdit", {
                        ...item,
                        ...allitem,
                        ...route.params,
                        type:
                          item.athlete_id != undefined &&
                          item.athlete_id != null
                            ? "Athlete"
                            : "Official",
                        name,
                      });
                    }}
                    style={styles.buttomDetail}
                  >
                    <Text style={styles.textButtonDetail}>EDIT</Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={[styles.buttomDetail, { marginLeft: 10 }]}
                  >
                    <Text style={styles.textButtonDetail}>DELETE</Text>
                  </TouchableOpacity>
                </View>
              )}
              <Text numberOfLines={1} style={[stylesResponsive.textTopic]}>
                GENDER
              </Text>
              <Text numberOfLines={1} style={[stylesResponsive.textDetail]}>
                {item.Athlete.gender}
              </Text>
              <Text numberOfLines={1} style={[stylesResponsive.textTopic]}>
                BIRTH
              </Text>
              <Text numberOfLines={1} style={stylesResponsive.textDetail}>
                {moment(item.Athlete.birth_date).format("DD-MM-YYYY")}
              </Text>
              <Text numberOfLines={1} style={[stylesResponsive.textTopic]}>
                PASSPORT
              </Text>
              <Text numberOfLines={1} style={stylesResponsive.textDetail}>
                {item.Athlete.passport}
              </Text>
              <Text numberOfLines={1} style={[stylesResponsive.textTopic]}>
                TYPE
              </Text>
              <Text numberOfLines={1} style={stylesResponsive.textDetail}>
                {"ATHLETE"}
              </Text>
              <Text numberOfLines={1} style={[stylesResponsive.textTopic]}>
                EVENTS
              </Text>
              <Text numberOfLines={1} style={stylesResponsive.textDetail}>
                {item.Events == "" ? "-" : item.Events}
              </Text>
              <Text numberOfLines={1} style={[stylesResponsive.textTopic]}>
                PERSONAL BEST
              </Text>
              <Text numberOfLines={1} style={[stylesResponsive.textDetail]}>
                {item.BestTimePersonal == "" ? "-" : item.BestTimePersonal}
              </Text>
              <Text numberOfLines={1} style={[stylesResponsive.textDetail]}>
                {item.DatePersonal}
              </Text>
              <Text numberOfLines={1} style={[stylesResponsive.textDetail]}>
                {item.CountryPersonal}
              </Text>
              <Text numberOfLines={1} style={[stylesResponsive.textTopic]}>
                SEASON BEST
              </Text>
              <Text numberOfLines={1} style={[stylesResponsive.textDetail]}>
                {item.BestTimeSeason == "" ? "-" : item.BestTimeSeason}
              </Text>
              <Text numberOfLines={1} style={[stylesResponsive.textDetail]}>
                {item.DateSeason}
              </Text>
              <Text numberOfLines={1} style={[stylesResponsive.textDetail]}>
                {item.CountrySeason}
              </Text>
            </View>
          </View>
        );
      }}
    />
  );
}
